/**
 * @copyright Copyright 2021 Epic Systems Corporation
 * @file live apps store updater methods
 * @module Epic.AppOrchard.StoreMethods.LiveApps
 */

import { IDispatch } from "@epic/react-redux-booster";
import { liveAppsActions } from "ao/state/widgets/liveApps";
import { ILiveApp } from "ao/types";

/**
 * Update store with apps after loading from server
 * @param dispatch for useDispatch
 * @param orgId customer org id
 * @param apps apps for customer org
 */
export function updateAppsAfterLoad(dispatch: IDispatch, orgId: number, apps: ILiveApp[]) {
	dispatch(liveAppsActions.updateAppsAfterLoad({ orgId, apps }));
}

/**
 * Clear loaded flag to force components to reload apps from server,
 * for example when a new live app is created in another widget
 * @param dispatch for useDispatch
 * @param orgId customer org id
 */
export function clearLoaded(dispatch: IDispatch, orgId: number) {
	dispatch(liveAppsActions.clearLoaded(orgId));
}
